import React from 'react';
import ForgotPasswordFunctional from './components/forgot-password-functional';
import './forgot-password.scss';

const ForgotPassword = () => {
	return <ForgotPasswordFunctional />;
};

export default ForgotPassword;
